export default __webpack_public_path__ + "static/media/bookform-01.3dc9bc20.png";